import { Alert, Box, Snackbar, Tab } from "@mui/material";
import { Button } from "@mui/material";
import { GoArrowUpRight } from "react-icons/go";

export function ToastNotify({ alertState, setAlertState }) {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={alertState.open}
      autoHideDuration={10000}
      key={"top center"}
      onClose={() => setAlertState({ ...alertState, open: false })}
    >
      <Alert
        onClose={() => setAlertState({ ...alertState, open: false })}
        severity={alertState.severity}
      >
        {alertState.message}
      </Alert>
    </Snackbar>
  );
}

export function StyledButton({ children, ...props }) {
  return (
    <>
      <Button
        {...props}
        sx={{
          color: "#000000",
          background:
            "linear-gradient(0deg, #F7F7F7, #F7F7F7),linear-gradient(0deg, #FFFFFF, #FFFFFF)",
          fontSize: { xs: "16px", sm: "18px" },
          textTransform: "capitalize",
          fontFamily: "Saira Semi Condensed",
          fontWeight: "700",
          borderRadius: "12px",
          border: "1px solid #000000",
          width: props.width,
          height: "50px",
          px: props.px ? props.px : 0,
          "&.Mui-disabled": {
            color: "#979EA7",
          },
          "&:hover": {
            background:
              "linear-gradient(0deg, #F7F7F7, #F7F7F7),linear-gradient(0deg, #FFFFFF, #FFFFFF)",
            // background: "#121212",
          },
        }}
      >
        {children}
      </Button>
    </>
  );
}

export function StyledText({ children, ...props }) {
  return (
    <>
      <Box
        {...props}
        sx={{
          color: "#000000",
          fontSize: "18px",
          //   fontFamily: "Josefin Sans",
          fontWeight: "500",
          mr: props.mr,
        }}
      >
        {children}
      </Box>
    </>
  );
}
export function StyledTitle({ children, ...props }) {
  return (
    <>
      <Box
        {...props}
        sx={{
          color: "#000000",
          fontSize: "40px",
          //   fontFamily: "Josefin Sans",
          fontWeight: "700",
          mr: props.mr,
        }}
      >
        {children}
      </Box>
    </>
  );
}

export function StyledArrowButton({ children, ...props }) {
  return (
    <>
      <Button
        endIcon={
          <GoArrowUpRight
            style={{
              color: "#8102FF",
            }}
          />
        }
        {...props}
        sx={{
          color: "#ffffff",
          background: "transparent",
          fontSize: { xs: "14px", sm: "16px" },

          textTransform: "uppercase",
          fontFamily: "Saira Semi Condensed",
          fontWeight: "700",
          letterSpacing: "1px",
          border: "3px solid #ffffff",
          width: props.width,
          height: "50px",
          px: props.px ? props.px : 0,
          "&.Mui-disabled": {
            color: "#979EA7",
          },
          "&:hover": {
            background: "transparent",
          },
        }}
      >
        {children}
      </Button>
    </>
  );
}

export const toLocalFormat = (val) => {
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export function StyledTab({ children, ...props }) {
  return (
    <>
      <Tab
        {...props}
        sx={{
          color: "#D9D9D9",
          borderRadius: "30px",
          ml: props?.marginLeft,
          fontSize: { xs: "14px", sm: "16px" },
          fontFamily: "Saira Semi Condensed",
          letterSpacing: "1px",
          fontWeight: "600",
          width: props.width,
          textTransform: "none",
          "&.Mui-selected": {
            color: "#ffffff",
            background: "#8102FF",
            borderRadius: "30px",
            filter: "none",
          },
        }}
        label={children}
      />
    </>
  );
}
